import { equalObject } from '../utils.js';
import { season$ } from '../stores/store-main.js';
export const GRADE_FITNESS_LEVELS = {
    easy: true,
    medium: true,
    difficult: true,
};
export const GRADE_SKIING = {
    classic: true,
    skating: true,
    both: true,
};
export const HANDICAP_SWITCH_ITEMS = [
    { label: () => 'Routes', value: 'routes' },
    { label: () => 'Obstacle-free routes', value: 'handicap' },
];
export const MOUNTAINBIKE_SWITCH_ITEMS = [
    { label: () => 'Routes', value: 'routes' },
    { label: () => 'Mountain bike facilities', value: 'structures' },
];
export const DEFAULT_LAND_CODES = {
    winter: 'winterhike',
    summer: 'hike',
};
export const STRUCTURES_GROUP_NUMBER = 1;
export function defaultFilterValues() {
    const season = season$.value;
    return {
        season: season,
        land: DEFAULT_LAND_CODES[season],
        categories: {
            national: true,
            regional: true,
            local: true,
            handicap: false,
            trails: true,
        },
        grades: { ...GRADE_FITNESS_LEVELS },
        gradesSkiing: { ...GRADE_SKIING },
        fitness: { ...GRADE_FITNESS_LEVELS },
        canton: 0,
        specialInterests: {
            day: false,
            bookable: false,
            groups: {
                canoe: [],
                crosscountry: [],
                cycle: [],
                hike: [],
                mountainbike: [],
                skate: [],
                sledge: [],
                snowshoe: [],
                winterhike: [],
            },
        },
        structures: false,
    };
}
export function hasGrade(filter) {
    return (filter.land !== 'cycle' &&
        filter.land !== 'winterhike' &&
        filter.land !== 'snowshoe' &&
        filter.land !== 'crosscountry' &&
        !filter.structures);
}
export function hasFitness(filter) {
    return filter.land !== 'sledge' && !filter.structures;
}
export function hasCategories(filter) {
    return (!filter.structures &&
        !filter.categories.handicap &&
        filter.season !== 'winter');
}
export function hasFitnessGrade(filter) {
    return (hasGrade(filter) || hasFitness(filter) || filter.land === 'crosscountry');
}
export function isFilterDirty(filter) {
    const defaultValues = defaultFilterValues();
    const specialInterestsGroups = Object.values(filter.specialInterests.groups);
    const specialInterestsGroupsIsSet = specialInterestsGroups.some((group) => group.some((v) => v.checked));
    return (defaultValues.land !== filter.land ||
        defaultValues.season !== filter.season ||
        !equalObject(defaultValues.categories, filter.categories) ||
        !equalObject(defaultValues.grades, filter.grades) ||
        !equalObject(defaultValues.gradesSkiing, filter.gradesSkiing) ||
        !equalObject(defaultValues.fitness, filter.fitness) ||
        defaultValues.canton !== filter.canton ||
        defaultValues.specialInterests.day !== filter.specialInterests.day ||
        defaultValues.specialInterests.bookable !==
            filter.specialInterests.bookable ||
        specialInterestsGroupsIsSet);
}
//# sourceMappingURL=filter.js.map